import classnames from "classnames";
import React from "react";
import {
    Checkbox as BaseCheckbox,
    composeRenderProps,
} from "react-aria-components";

import Checkmark from "../../public/svg/checkmark.svg";

import styles from "./checkbox.module.scss";

export const Checkbox = ({
    className,
    children,
    ...props
}: React.ComponentProps<typeof BaseCheckbox>) => {
    return (
        <BaseCheckbox
            {...props}
            className={composeRenderProps(className, (className) =>
                classnames([className, styles.root]),
            )}
        >
            {composeRenderProps(children, (children, props) => (
                <>
                    <span aria-hidden className={styles.checkbox}>
                        {props.isSelected && (
                            <Checkmark className={styles.checkmark} />
                        )}
                    </span>
                    {children}
                </>
            ))}
        </BaseCheckbox>
    );
};
